module.exports = __webpack_public_path__ + "img/65.a6f28c01.png";